import {mutationTypes} from '@/core/constants'
import keycloak from '@/application/engine/KeycloakService'

export default {

    [mutationTypes.COMUM.SET_CURRENT_PAGE](state, to) {
        if (to.meta && to.meta.page) {
            state.comum.page.title = to.meta.page.title
            state.comum.page.subtitle = to.meta.page.subtitle
            state.comum.page.requiresAuth = to.meta.requiresAuth
        }
    },

    [mutationTypes.COMUM.EFETUAR_LOGOUT]() {
        keycloak.logout()
    },

    [mutationTypes.COMUM.SET_TIMEZONE](state, timezone) {
        state.comum.timezone = timezone
    },

    [mutationTypes.COMUM.SET_NOTIFICACAO](state, dados) {
        state.notificacao = {
            cor: dados.cor,
            titulo: dados.titulo,
            mensagem: dados.mensagem,
            mostrar: dados.mostrar,
            eventoClick: dados.eventoClick
        }
    },

    [mutationTypes.COMUM.SET_USUARIO_LOGADO_UPDATE](state, usuario) {
        state.comum.usuarioLogado = usuario
    },

    [mutationTypes.COMUM.SET_GLOBAL_LOADING](state, loading) {
        if (state.comum.isGlobalLoadingEnabled) {
            state.comum.isLoading = loading
        } else if (!loading) {
            state.comum.isLoading = loading
        }
    },

    [mutationTypes.COMUM.SET_LOADING_MESSAGE](state, message) {
        state.comum.loadingMessage = message
    },

    [mutationTypes.COMUM.SET_REDIRECT_URL](state, redirectPage) {
        state.comum.redirectPage = redirectPage
    },
}
